import { authedApiInstance } from '../firebase';

export const getLinkSummary = async (url) =>
  authedApiInstance
    .get('linkSummary', { params: { q: url } })
    .then((response) => response.data)
    .catch((error) => error?.response?.data);
